import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddSongFrom, catalogAddSongPath } from './catalogAddSongPath';

/** Opens the step-by-step "Add a song" page (design catalog-add-song). Close comes back to `from`. */
export function useOpenAddSong(from: AddSongFrom, accountId: number | null): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    // eslint-disable-next-line no-void -- a router navigation: nothing to wait for
    void navigate(catalogAddSongPath({ from, accountId }));
  }, [accountId, from, navigate]);
}
